import * as React from 'react';
import styled from 'styled-components';
import { SurvyResponse } from '../../../amorg-common';

type ThanksContactFormProps = {
    details: SurvyResponse['respondentDetails'];
    onDetailsChange: (details: SurvyResponse['respondentDetails']) => void;
};

export function ThanksContactForm(props: ThanksContactFormProps): JSX.Element {
    return (
        <div>
            <Text>
                Få jeres rapport vurderet af CreceaJoblifes arbejdsmiljørådgiver.
                Felterne er valgfri og bruges kun hvis du vil kontaktes om besvarelsen.
            </Text>
            <Grid>
                <Input value={props.details.name} placeholder='Navn (valgfri)' onChange={e => updateField('name', e.target.value)} />
                <Input value={props.details.email} placeholder='E-mail (valgfri)' onChange={e => updateField('email', e.target.value)} />
                <Input value={props.details.organization} placeholder='Organisation (valgfri)' onChange={e => updateField('organization', e.target.value)} />
                <Input value={props.details.role} placeholder='Rolle (valgfri)' onChange={e => updateField('role', e.target.value)} />
                <TextArea value={props.details.message} placeholder='Besked (valgfri)' onChange={e => updateField('message', e.target.value)} />
            </Grid>
        </div>
    );

    function updateField(field: keyof SurvyResponse['respondentDetails'], value: string) {
        props.onDetailsChange({
            ...props.details,
            [field]: value
        });
    }
}


const Text = styled.p`
    margin: 0 0 8px;
`;

const Grid = styled.div`
    display: grid;
    gap: 10px;
`;

const Input = styled.input`
    width: 100%;
    border: 1px solid #c7c7c7;
    border-radius: 8px;
    padding: 10px 12px;
`;

const TextArea = styled.textarea`
    width: 100%;
    border: 1px solid #c7c7c7;
    border-radius: 8px;
    padding: 10px 12px;
    min-height: 120px;
`;
